An array of physical addresses for the person.

The physical addresses are ordered in descending preference.

Between 0 and 5 physical addresses may be provided, inclusive.
